<div class="flex w-full flex-col">
  <p class="mb-2 text-sm text-gray-800 leading-none" *ngIf="showCount">
    {{ 'exposures.numberOfMediaFiles' | translate: {count: data.length} }}
  </p>

  <div class="flex flex-wrap overflow-auto min-h-14 max-h-24 border border-neutral-200 p-3 gap-2 rounded">
    <ng-container *ngFor="let item of data; let i = index">
      <span
        class="px-2 py-1 rounded text-sky-800 text-sm font-medium text-nowrap cursor-pointer hover:bg-brand-chathams-blue hover:text-white transition-all duration-200 ease-in-out"
        [ngClass]="selectedMediaIndex === i ? 'bg-brand-chathams-blue text-white' : 'bg-gray-200'"
        (click)="selectMedia(item, i)">
        {{item.name}}
      </span>
    </ng-container>
  </div>
</div>
